import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Calendar, Phone } from 'lucide-react';
export function CTASection() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 bg-slate-900 text-white" id="contact" data-id="element-37">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-38">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-39">
          {t('Ready to take the next step?', '¿Listo/a para el siguiente paso?')}
        </h2>
        <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-40">
          {t('Schedule a consultation to discuss options tailored to your medical history and goals.', 'Agenda una consulta para hablar de opciones según tu historial y tus objetivos.')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-41">
          <button className="inline-flex items-center justify-center px-8 py-4 bg-teal-600 hover:bg-teal-500 text-white font-bold rounded-lg transition-all shadow-lg hover:shadow-teal-500/25 text-lg" data-id="element-42">
            <Calendar className="w-5 h-5 mr-2" data-id="element-43" />
            {t('Schedule a Consultation', 'Agendar consulta')}
          </button>
          <a href="tel:4849341070" className="inline-flex items-center justify-center px-8 py-4 bg-transparent border-2 border-slate-600 hover:border-white text-white font-semibold rounded-lg transition-all hover:bg-white/5 text-lg" data-id="element-44">
            <Phone className="w-5 h-5 mr-2" data-id="element-45" />
            {t('Call 484-934-1070', 'Llamar al 484-934-1070')}
          </a>
        </div>
      </div>
    </section>;
}